export const AuthConstants = {
    MeEndpoint: '/auth/me', // GET → current user (uses cookies)
    RefreshEndpoint: '/auth/refresh', // POST → sets new cookies
    LoginEndpoint: '/Login', // server page that performs login
    LogoutEndpoint: '/auth/logout', // GET → clears cookies
    Debug: true,
};
